import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAuth } from "../hooks/useAuth";

import './Login.scss';

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const { login } = useAuth();

    const navigate = useNavigate();

    const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            setLoading(true);
            login(username, password)
                .then(() => navigate("/trackers", { replace: false }))
                .catch(() => alert("Invalid username or password"))
                .then(() => setLoading(false))
    };

    return (
        <div className="login-page">
            <form className="block-form" onSubmit={handleLogin}>
                <div className="line-input">
                    <label htmlFor="username">Username:</label>
                    <input
                        id="username"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div className="line-input">
                    <label htmlFor="password">Password:</label>
                    <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <button className="valid-button" type="submit" disabled={loading}>
                    <span>Login</span>
                    { loading
                        ? <FontAwesomeIcon icon="spinner" spin />
                        : <FontAwesomeIcon icon="sign-in-alt" />
                    }
                </button>
            </form>
        </div>
    );
};